<template>
  <FriedParagraph
    :size="small ? 'small' : 'medium'"
    :class="{ bold, red, indent, 'align-right': alignRight, 'has-branding': hasBranding }"
  >
    {{ text }}
  </FriedParagraph>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { useInjectBrandingState } from '../../../composables';
import { getHexFromVariable } from '../../../helpers';

interface Props {
  text: string;
  alignRight?: boolean;
  bold?: boolean;
  red?: boolean;
  small?: boolean;
  indent?: boolean;
  muted?: boolean;
}
withDefaults(defineProps<Props>(), {});

const { branding } = useInjectBrandingState();

const hasBranding = computed(
  () => branding.value?.pricingTable?.headerBackgroundColor !== getHexFromVariable('--gray-96')
);
</script>
<style lang="scss" scoped>
.paragraph.medium,
.paragraph.small {
  font-family: var(--editor-default-font-family);
  color: var(--editor-pricing-table-header-text-color);
  word-break: break-word;
  text-align: left;

  &.bold {
    font-weight: 600;
  }

  &.red {
    color: var(--red-42);
    border-radius: var(--editor-medium-border-radius);

    &.has-branding {
      background: var(--white);
    }
  }

  &.align-right {
    text-align: right;
  }

  &.muted {
    color: var(--editor-pricing-table-placeholder-text-color);
    opacity: 0.65;
  }
}

.indent {
  padding-left: var(--spacing-100);
}
</style>
